import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getAllPersonas, getRecentWorks } from "../../../../redux/index";
import DataLoader from "shared/components/data-loader";
import styled from "styled-components";
import { RecentWorkCard } from "./RecentWorkCard";
import { RecentWorkEmpty } from "./RecentWorkEmpty";

export const RecentWork = () => {
	const { t } = useTranslation();

	return (
		<RecentWorkContainer>
			<SectionTitle>{t("RECENT_WORK")}</SectionTitle>
			<SectionBody>
				<DataLoader reduxActions={[getRecentWorks, getAllPersonas]}>
					<RecentWorkLoaded />
				</DataLoader>
			</SectionBody>
		</RecentWorkContainer>
	);
};

const RecentWorkLoaded = () => {
	const recentWorks = useSelector(({ settings }: any) => settings?.recentWorks);
	return (
		<>
			{recentWorks?.length > 0 ? (
				<RecordsContainer>
					{recentWorks?.map((recentWork: any, i: number) => (
						<div key={i}>
							<RecentWorkCard {...recentWork} />
						</div>
					))}
				</RecordsContainer>
			) : (
				<RecentWorkEmpty />
			)}
		</>
	);
};

const RecentWorkContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	margin-bottom: 48px;
`;

const SectionTitle = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
`;

const SectionBody = styled.div`
	position: relative;
	min-height: 160px;
`;

const RecordsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 28px;
`;
